import { Injectable } from "@angular/core";
import { HttpClient, HttpContext, HttpHeaders, HttpParams, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment"
import { CurrentUserModel } from "../models/current-user.model";
import { param } from "jquery";
//import { HttpRequest } from "@microsoft/signalr";

@Injectable({
    providedIn: "root"
})
export class ApiService {
    private baseRoute: string;
    private headers: HttpHeaders;
    private params: HttpParams;

    constructor(private httpClient: HttpClient) {
        this.baseRoute = environment.apiRoot + "api/";
        if (localStorage.access_token != null) {
            this.headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer `  + localStorage.access_token
              });

            const currentUser: CurrentUserModel = JSON.parse(localStorage.currentUser);
            let UserIdentity = currentUser.id;
            this.params = new HttpParams().set('UserIdentity', UserIdentity);
            //.set('UserId', localStorage.userID);
        } else {
            this.headers = new HttpHeaders();
            this.params = new HttpParams();
        }
    }

    get route() {
      return this.baseRoute;
    }

	get<T>(route: string): Observable<T> {
        return this.httpClient.get<T>(`${this.baseRoute}${route}`, {
            headers: this.headers,
            params: this.params
        });
    }

    post<T>(route: string, payload: any = null): Observable<T> {
        return this.httpClient.post<T>(`${this.baseRoute}${route}`, payload, {
            headers: this.headers,
            params: this.params
        });
    }

    postText(route: string, payload: any = null): Observable<string> {
        return this.httpClient.post(`${this.baseRoute}${route}`, payload, {
            headers: this.headers,
            params: this.params,
            responseType: 'text'
        });
    }

    posth<T>(route: string, payload: any = null, headers: any): Observable<T> {
        return this.httpClient.post<T>(`${route}`, payload, {
            headers: headers
        });
    }

    postwh<T>(route: string, payload: any, headers: HttpHeaders): Observable<T> {
        return this.httpClient.post<T>(`${this.baseRoute}${route}`, payload, {
            headers: headers
        });
    }

    put<T>(route: string, payload: any = null): Observable<T> {
        return this.httpClient.put<T>(`${this.baseRoute}${route}`, payload, {
            headers: this.headers,
            params: this.params
        });
    }

    delete<T>(route: string): Observable<T> {
        return this.httpClient.delete<T>(`${this.baseRoute}${route}`, {
            headers: this.headers,
            params: this.params
        });
    }

    getFile(route: string): Observable<Blob> {
        return this.httpClient.get(`${this.baseRoute}${route}`, {
            headers: this.headers,
            params: this.params,
            responseType: 'blob'
        });
    }
    
}